import type { ChangeEvent } from "react";

import {
  FloatingLabelSelect,
  LabelInput,
} from "../../../components/Reusable/Layout";

type ReferralSettingsFieldsProps = {
  referralEligible: string;
  referralAmount: string;
  priceType: string;
  onChange: (
    event: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void;
};

export const ReferralSettingsFields = ({
  referralEligible,
  referralAmount,
  priceType,
  onChange,
}: ReferralSettingsFieldsProps) => {
  const isPercent = priceType === "percent";

  return (
    <div className="space-y-4 rounded-lg border border-inputBorder p-4">
      <p className="text-sm font-semibold text-gray-700 dark:text-white">
        Referral reward (credited as DG Points)
      </p>
      <FloatingLabelSelect
        name="referral_eligible"
        placeholder="Referral Eligible"
        value={referralEligible}
        onChange={onChange}
        options={[
          { value: "0", label: "No" },
          { value: "1", label: "Yes" },
        ]}
      />
      <LabelInput
        type="number"
        name="referral_amount"
        placeholder={
          isPercent
            ? "Referral Reward (% of Purchase)"
            : "Fixed Referral Amount (Plan Currency)"
        }
        value={referralAmount}
        onChange={onChange}
        disabled={referralEligible !== "1"}
        min={referralEligible === "1" ? 0.01 : 0}
        max={isPercent ? 100 : undefined}
        step="0.01"
        required={referralEligible === "1"}
      />
      <p className="text-xs text-gray-500 dark:text-gray-400">
        {isPercent
          ? "Calculates this percentage of the successful purchase amount, then converts it to DG Points."
          : "Converts this fixed amount from the plan’s price currency to DG Points after a successful eligible purchase."}
      </p>
    </div>
  );
};

export const referralEligibilityToFormValue = (
  value: boolean | number | string | null | undefined,
) => (value === true || value === 1 || value === "1" ? "1" : "0");
